// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transactions_switcher {
    display: flex;
    flex-direction: row;
    padding: 4px;
    border-radius: var(--radius-md);
    background-color: var(--bg);
    width: max-content;
    margin: auto;
    border: 1px solid var(--border-light);
}

.transactions_tab {
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    transition: all var(--transition-fast);
}

.transactions_tab_select {
    background-color: var(--primary);
    color: white;
    box-shadow: var(--shadow-sm);
}

.transactions_tab_not_select {
    background-color: transparent;
    color: var(--text-secondary);
}

.transactions_tab_not_select:hover {
    color: var(--text-primary);
    background-color: var(--bg-card);
}
`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/Transactions/transactions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;AACpC","sourcesContent":[".transactions_switcher {\n    display: flex;\n    flex-direction: row;\n    padding: 4px;\n    border-radius: var(--radius-md);\n    background-color: var(--bg);\n    width: max-content;\n    margin: auto;\n    border: 1px solid var(--border-light);\n}\n\n.transactions_tab {\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    transition: all var(--transition-fast);\n}\n\n.transactions_tab_select {\n    background-color: var(--primary);\n    color: white;\n    box-shadow: var(--shadow-sm);\n}\n\n.transactions_tab_not_select {\n    background-color: transparent;\n    color: var(--text-secondary);\n}\n\n.transactions_tab_not_select:hover {\n    color: var(--text-primary);\n    background-color: var(--bg-card);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
